<template>
	<div id="techSupport">
		<NavigationBar />

		<div class="uk-section" 
				id="topBanner" 
				:style="{ backgroundImage: `url(${ banner })` }" >
			<div class="uk-container">
				<div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
					<div class="uk-text-center">
						<p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Smart Home Appliance Store</p>
						<p class="uk-heading-small uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Collections</p>
					</div>
				</div>
			</div>
		</div>

		<section class="uk-section" id="section-five">
      <!-- DESKTOP -->
      <div class="uk-container uk-visible@s">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1@s uk-text-center">
            <p class="uk-text-default" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Timeless Appeal</p>
            <p class="uk-heading-small uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Explore Our Collections</p>
            <p class="font-description uk-text-light uk-margin-large-left uk-margin-large-right" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Discover the perfect addition to your smart home setup with our curated collections of smart appliances, audio, and security products.</p>
          </div>
        </div>
        <div class="uk-flex uk-flex-between uk-margin" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">
          <button class="uk-button uk-button-link uk-text-primary">All</button>
          <button @click="openCategory('smart-led')" class="uk-button uk-button-link">Smart Led</button>
          <button @click="openCategory('smart-camera')" class="uk-button uk-button-link">Smart Camera</button>
          <button @click="openCategory('smart-tv')" class="uk-button uk-button-link">Smart TV</button>
          <button @click="openCategory('android-box')" class="uk-button uk-button-link">Android Box</button>
          <button @click="openCategory('speaker')" class="uk-button uk-button-link">Speaker</button>
          <button @click="openCategory('digital-led-tv')" class="uk-button uk-button-link">Digital Led TV</button>
        </div>
        <div class="uk-grid" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
          <div class="uk-width-1-3@s uk-text-center" v-for="product in 9">
            <img class="uk-width-1-1" :src="require('../assets/images/home/promoted.jpg')" alt="TV Image">
          </div>
        </div>
      </div>

      <!-- MOBILE -->
      <div class="uk-margin-left uk-margin-right uk-hidden@s">
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1@s uk-text-center">
            <p class="uk-margin-large-top uk-text-default" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Timeless Appeal</p>
            <p class="uk-text-large uk-margin-remove-top uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Explore Our Collections</p>
            <p class="uk-text-light uk-margin-large-left uk-margin-large-right" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Discover the perfect addition to your smart home setup with our curated collections of smart appliances, audio, and security products.</p>
          </div>
        </div>
        <div class="uk-grid uk-flex-center uk-grid-small uk-margin-large-top" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;" uk-grid>
          <button class="uk-button uk-button-link uk-text-primary uk-text-center">All</button>
          <button class="uk-button uk-button-link uk-text-center">Audio & Speakers</button>
          <button class="uk-button uk-button-link uk-text-center">Home Appliances</button>
          <button class="uk-button uk-button-link uk-text-center">Refrigerators</button>
          <button class="uk-button uk-button-link uk-text-center">Smart TV & Security</button>
          <button class="uk-button uk-button-link uk-text-center">Vacuum cleaners</button>
          <button class="uk-button uk-button-link uk-text-center">Washing machines</button>
        </div>
        <div class="uk-grid" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
          <div class="uk-width-1-3@s uk-text-center" v-for="product in 9">
            <img class="uk-width-1-1" :src="require('../assets/images/home/promoted.jpg')" alt="TV Image">
          </div>
        </div>
      </div>
    </section>

    <div class="uk-section uk-background-secondary">
      <div class="uk-container">
        <div class="uk-grid uk-grid-large" uk-grid ref="grid">
          <div class="uk-width-1-3@s">
            <div class="">
              <h1 class="font-white uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Revolutionizing Your Home Entertainment</h1>
              <p class="font-white font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">At ROOMI, we curate the best home appliances and audio systems to create an immersive entertainment experience. Whether you’re looking for a Smart TV, home speakers, or portable speakers, we have the perfect solution for you. Explore our collections today and discover the future of home entertainment.</p>
              <button class="uk-button uk-button-muted uk-margin-top uk-margin-bottom" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Discover More</button>
            </div>
          </div>
          <div class="uk-width-1-3@s">
            <div class="uk-text-center">
              <h1 class="font-white uk-text-bold uk-heading-medium">
                <transition name="number-slide">
                  <span v-if="showNumber2">+{{ number2 }}</span>
                </transition>
              </h1>
              <h1 class="font-white uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Smart TV</h1>
              <p class="font-white font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">We offer the latest home appliances to make your life easier. From air conditioners to refrigerators, we have everything you need to create a comfortable and convenient living space.</p>
            </div>
          </div>
          <div class="uk-width-1-3@s">
            <div class="uk-text-center">
              <h1 class="font-white uk-text-bold uk-heading-medium">
                <transition name="number-slide">
                  <span v-if="showNumber3">+{{ number3 }}</span>
                </transition>
              </h1>
              <h1 class="font-white uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Speaker</h1>
              <p class="font-white font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Our collection of audio and speakers are designed to deliver the best sound quality and immersive listening experience. From home speakers to portable speakers, we have the perfect solution for your needs.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="uk-section" id="section-five">
      <div class="uk-container">
        <div class="uk-grid ukflex uk-flex-middle" uk-grid>
          <div class="uk-width-1-2@s">
            <p class="uk-text-primary" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Tailored Excellence</p>
            <p class="uk-heading-small uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Secure and Smart</p>
            <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Our Smart TV and Security collection offers advanced features such as Google TV and Smart CCTV to make your home more secure and connected. Experience the future of home security and entertainment with ROOMI.</p>
            <button class="uk-button uk-button-primary uk-margin-top" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">See Products</button>
          </div>
          <div class="uk-width-1-2@s">
            <div class="uk-grid uk-grid-small" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
              <div class="uk-width-1-2@s uk-text-center" v-for="product in 4">
                <img class="uk-width-1-1" :src="require('../assets/images/home/promoted.jpg')" alt="TV Image">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section uk-background-secondary" id="section-five">
      <div class="uk-container">
        <!-- DESKTOP -->
        <div class="uk-margin-large-left uk-margin-large-right uk-visible@s" uk-slideshow="autoplay: true" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">
          <div class="uk-slideshow-items " style="height: 250px !important;">
            <div class="font-white uk-padding">
              <p class="uk-text-light text-white uk-text-center">A jewelry store that turns dreams into reality! The level of personalization and the array of choices made the entire process a joy. The craftsmanship is unparalleled, and the final result was nothing short of perfection.</p>
              <div class="uk-flex uk-flex-middle uk-flex-center" >
                <img width="120" height="120" class="circle-image" :src="require('../assets/images/home/office.jpeg')" alt="TV Image">
                <div class="uk-text-left uk-margin-left">
                  <p class="text-white uk-text-large uk-margin-remove">Erwin</p>
                  <p class="text-white uk-margin-remove uk-text-muted">Influencer</p>
                </div>
              </div>
            </div>
            <div class="font-white uk-padding">
              <p class="uk-text-light text-white uk-text-center">The craftsmanship is unparalleled, and the final result was nothing short of perfection. A jewelry store that turns dreams into reality! The level of personalization and the array of choices made the entire process a joy.</p>
              <div class="uk-flex uk-flex-middle uk-flex-center" >
                <img width="120" height="120" class="circle-image" :src="require('../assets/images/home/office.jpeg')" alt="TV Image">
                <div class="uk-text-left uk-margin-left">
                  <p class="text-white uk-text-large uk-margin-remove">Krishna</p>
                  <p class="text-white uk-margin-remove uk-text-muted">Influencer</p>
                </div>
              </div>
            </div>
          </div>
          <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin" uk-slideshow-nav></ul>
        </div>

        <!-- MOBILE -->
        <div class="uk-flex-middle">
          <div class="uk-hidden@s" uk-slideshow="autoplay: true" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">
            <div class="uk-slideshow-items" style="height: 200px !important;">
              <div class="font-white">
                <p class="uk-text-light text-white uk-text-center">A jewelry store that turns dreams into reality! The level of personalization and the array of choices made the entire process a joy. The craftsmanship is unparalleled, and the final result was nothing short of perfection.</p>
                <div class="uk-flex uk-flex-middle uk-flex-center" >
                  <img width="60" height="60" class="circle-image" :src="require('../assets/images/home/office.jpeg')" alt="TV Image">
                  <div class="uk-text-left uk-margin-left">
                    <p class="text-white uk-margin-remove">Erwin</p>
                    <p class="text-white uk-margin-remove uk-text-muted">Influencer</p>
                  </div>
                </div>
              </div>
              <div class="font-white">
                <p class="uk-text-light text-white uk-text-center">The craftsmanship is unparalleled, and the final result was nothing short of perfection. A jewelry store that turns dreams into reality! The level of personalization and the array of choices made the entire process a joy.</p>
                <div class="uk-flex uk-flex-middle uk-flex-center" >
                  <img width="60" height="60" class="circle-image" :src="require('../assets/images/home/office.jpeg')" alt="TV Image">
                  <div class="uk-text-left uk-margin-left">
                    <p class="text-white uk-margin-remove">Krishna</p>
                    <p class="text-white uk-margin-remove uk-text-muted">Influencer</p>
                  </div>
                </div>
              </div>
            </div>
            <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin" uk-slideshow-nav></ul>
          </div>
        </div>
      </div>
    </section>

		<!-- <h1 class="uk-heading-divider"></h1> -->
		<Footer />
	</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Footer from '@/components/Footer.vue'
import $axios from '../api.js'
import UIkit from 'uikit'

export default {
	name: 'techSupport',
	components: {
		NavigationBar,
		Footer
	},
	data () {
		return {
			banner: require('../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
			number1: 0,
      number2: 0,
      number3: 0,
      showNumber1: false,
      showNumber2: false,
      showNumber3: false,
		}
	},
  mounted () {
    this.setupIntersectionObserver();
  },
	methods: {
		setupIntersectionObserver() {
      const options = {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin
        threshold: 0.5, // 50% of the component must be in view
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startAnimation();
            this.observer.unobserve(entry.target);
          }
        });
      }, options);

      this.observer.observe(this.$refs.grid); // observe the grid element
    },
    startAnimation() {
      this.showNumber1 = true;
      this.animateNumber(76, 'number1');
      this.showNumber2 = true;
      this.animateNumber(56, 'number2');
      this.showNumber3 = true;
      this.animateNumber(83, 'number3');
    },
    animateNumber(targetNumber, propName) {
      const increment = 1;
      const animate = () => {
        if (this[propName] < targetNumber) {
          this[propName] = Math.min(this[propName] + increment, targetNumber); 
          requestAnimationFrame(animate);
        }
      };

      animate();
    }
	}
}
</script>

<style scoped>

</style>